import React, { useEffect, useState } from 'react';
import './IssueWallet.css';
import {
  FaFileUpload,
  FaEye,
  FaEdit,
  FaTrash,
  FaPenFancy,
  FaArrowLeft,
  FaArrowRight,
  FaQrcode
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { deleteUserByEarthId, deleteWalletMappingByEarthId, generateDeviceId, getUserDetailsByEarthId, getWalletMappingsByIssuer, saveWalletMapping } from '../../api/wallet-mappingAPI';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // or 'style.css' for default look
import { sendEmailWithQRCode } from '../../api/supportAPI';
import { getMe } from '../../api/loginAPI';
import { createDid, generateKeyPair } from '../../api/ssiAPI';
import CryptoJS from 'crypto-js';
import { publishToHcs } from '../../api/auditAPI';


function IssueWallet() {
  const [formData, setFormData] = useState({
    name: '',
    lname: '',
    email: '',
    countryCode: '+91',
    phone: '',
    template: ''
  });

  const [certificates, setCertificates] = useState([]);
  const [bulkFile, setBulkFile] = useState(null);

  const [showForm, setShowForm] = useState(false);
  const [formMode, setFormMode] = useState('manual'); // 'manual' or 'bulk'
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

    const [user, setUser] = useState(null);

    const darkMode = document.body.classList.contains('dark-mode')
  
    useEffect(() => {
      async function fetchUser() {
        const userData = await getMe();
        console.log('UserData', userData)
        setUser(userData);
      }
      fetchUser();
    }, []);

  useEffect(() => {
//   const issuerId = sessionStorage.getItem('userId');
//   console.log('This is userID:', issuerId)
  if (user) {
    getWalletMappingsByIssuer(user.Id).then(setCertificates);
    console.log('these are the wallets',certificates)
  }
}, [user]);


  const generateFakeIMEI = async () => {
  const imei = '35' + Math.floor(100000000000000 + Math.random() * 900000000000000).toString().slice(0, 13);
  return imei;
};

function convertPublicKeyToDerFormat(uncompressedHex) {
  const EC_DER_PREFIX = '302a300506032b6570032100';

  // Strip the '04' prefix (uncompressed key format)
  const keyWithout04 = uncompressedHex.startsWith('04')
    ? uncompressedHex.slice(2)
    : uncompressedHex;

  // Take only the X-coordinate (first 64 characters = 32 bytes)
  const xOnly = keyWithout04.slice(0, 64);

  return EC_DER_PREFIX + xOnly;
}


const issueWalletAPI = async (firstName, lastName, email, phone, countryCode, publicKey) => {

  const deviceID = await generateDeviceId()
  const iemiNum = await generateFakeIMEI()
  const newPublicKey = await convertPublicKeyToDerFormat(publicKey)

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    username: email,
    firstname: firstName,
    lastname: lastName,
    deviceID: deviceID,
    deviceIMEI: iemiNum,
    deviceName: "EarthId",
    email: email,
    orgId: "234640ae-885f-4241-bc1b-10d2eb0295dc",
    phone: phone,
    countryCode: countryCode || "+91",
    publicKey: newPublicKey,
    deviceOS: "android"
  });

  console.log('This is raw data:', raw)

  try {
    const response = await fetch("https://stage-apiv2.myearth.id/user/registration", {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    });

    if (response.status === 409) {
      // Conflict - user exists
      // Warning alert
// Swal.fire({
//   icon: 'warning',
//   title: 'Conflict',
//   text: 'User with this phone/email already exists.',
//   background: '#1e1e2f',
//   color: '#fff',
//   customClass: {
//     confirmButton: 'swal2-confirm-dark'
//   }
// });
      return null;
    }

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API Error:", response.status, errorText);
    //  Swal.fire('Error', `Failed to register user: ${response.status}`, 'error');
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API Error:", error);
   // Swal.fire('Error', 'Network or server error occurred.', 'error');
    return null;
  }
};



  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

const handleSubmit = async e => {
    setShowForm(false)
    e.preventDefault();
    const { name, lname, email, phone, countryCode } = formData;

    if (!name || !lname || !email || !phone || !countryCode) {
      // Example for 'Error' alert
Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Please fill out all fields.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});

      return;
    }

    Swal.fire({
  title: 'Issuing Wallet...',
  text: 'Please wait while we issue the wallet.',
  allowOutsideClick: false,
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  iconColor: document.body.classList.contains('dark-mode') ? '#60a5fa' : '#048cd4',
  customClass: {
    popup: 'swal-custom'
  },
  didOpen: () => Swal.showLoading()
});

    //const issuerId = sessionStorage.getItem('userId');
    const keyPair = await generateKeyPair();
    const userDID = await createDid(keyPair.publicKey);
    const apiResponse = await issueWalletAPI(name, lname, email, phone, countryCode, keyPair.publicKey);
    console.log('This is issue wallet api response:', apiResponse)

    if (apiResponse?.conflict) {
     // Warning alert
Swal.fire({
  icon: 'warning',
  title: 'Conflict',
  text: 'User with this phone/email already exists.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
      return;
    }

    if (apiResponse && apiResponse.earthId && user.Id) {
    const mappingAPIRes =  await saveWalletMapping(
  String(user.Id),
  String(apiResponse.earthId),
  name + ' ' + lname,
  email
);
    console.log('This is wallet mapping api response:', mappingAPIRes)

      const qrData = {
        earthId: apiResponse.earthId,
        publicKey: keyPair.publicKey,
        privateKey: keyPair.privateKey,
        UserDid: userDID
      };
      const serializedData = JSON.stringify(qrData);
const secretKey = 'idv-sessions';
const encryptedData = CryptoJS.AES.encrypt(serializedData, secretKey).toString();

      await sendEmailWithQRCode(formData.email, encryptedData);

      const updatedList = await getWalletMappingsByIssuer(user.Id);
setCertificates(updatedList);

 const messageObj = {
              "event": "Single Wallet Issuance",
              "message": `Wallet issued successfully`,
              "timestamp": new Date().toISOString(),
              "status": "success"
            }
                await publishToHcs(messageObj)
                console.log('Published audit for single wallet Issuance')
    

      // Success alert
Swal.fire({
  icon: 'success',
  title: 'Success',
  text: 'Wallet issued successfully!',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
      setFormData({ name: '', lname: '', email: '', countryCode: '', phone: '', template: '' });
      setShowForm(false);
    } else {
      // Example for 'Error' alert
Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Failed to issue wallet.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
    }
  };


const handleBulkUpload = async () => {
  if (!bulkFile) {
   // Swal.fire('Error', 'Please select an Excel file before uploading.', 'error');
    Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Please select an Excel file before uploading.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
    return;
  }

 // Swal.fire('Uploading...', 'Processing Excel file...', 'info');
      Swal.fire({
  icon: 'info',
  title: 'Uploading...',
  text: 'Processing Excel file...',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
  console.log('🚀 Uploading file:', bulkFile.name);

  const reader = new FileReader();

  reader.onload = async (event) => {
    try {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(firstSheet);
      console.log('✅ Rows parsed:', rows);

      let successCount = 0;
      let failedCount = 0;

      for (const row of rows) {
        console.log('📄 Processing row:', row);

        const firstname = row.firstname?.trim();
        const lastname = row.lastname?.trim();
        const email = row.email?.trim();
        const phone = row.phone?.toString().trim();
        const countryCode = row.countryCode?.toString().trim() || '+44';

        if (!firstname || !lastname || !email || !phone) {
          console.warn('⚠️ Skipping invalid row:', row);
          failedCount++;
          continue;
        }

        const keyPair = await generateKeyPair();
        const userDID = await createDid(keyPair.publicKey);
        const res = await issueWalletAPI(firstname, lastname, email, phone, countryCode, keyPair.publicKey);

        if (res && res.earthId && user?.Id) {
          await saveWalletMapping(user.Id.toString(), res.earthId, `${firstname} ${lastname}`, email);

          const qrData = {
            earthId: res.earthId,
            publicKey: keyPair.publicKey,
            privateKey: keyPair.privateKey,
            UserDid: userDID
          };
          const encrypted = CryptoJS.AES.encrypt(JSON.stringify(qrData), 'idv-sessions').toString();
          await sendEmailWithQRCode(email, encrypted);
          successCount++;
        } else {
          failedCount++;
        }
      }

      const updatedList = await getWalletMappingsByIssuer(user.Id);
setCertificates(updatedList);

    //   Swal.fire(
    //     'Bulk Upload Complete',
    //     `${successCount} wallet(s) issued successfully.\n${failedCount} failed.`,
    //     'success'
    //   );

     const messageObj = {
                  "event": "Bulk Wallet Issuance",
                  "message": `Bulk wallets are issued successfully`,
                  "timestamp": new Date().toISOString(),
                  "status": "success"
                }
                    await publishToHcs(messageObj)
                    console.log('Published audit for Bulk Wallet Issuance')
        
    

            Swal.fire({
  icon: 'success',
  title: 'Bulk Issuance Complete',
  text: `${successCount} wallet(s) issued successfully.\n${failedCount} failed.`,
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
    } catch (err) {
      console.error('❌ Error parsing file:', err);
     // Swal.fire('Error', 'Failed to process the file.', 'error');
          Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Failed to process the file.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
    }
  };

  reader.readAsArrayBuffer(bulkFile);
};



const handleViewUser = async (earthId) => {
  const user = await getUserDetailsByEarthId(earthId);
  if (user) {
// User Details Modal
Swal.fire({
  title: 'User Details',
  html: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; padding: 10px;">
      <table style="width: 100%; border-collapse: collapse;">
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">Name</td>
          <td style="text-align: right; padding: 6px 4px;">${user.firstname} ${user.lastname}</td>
        </tr>
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">Email</td>
          <td style="text-align: right; padding: 6px 4px;">${user.email}</td>
        </tr>
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">Phone</td>
          <td style="text-align: right; padding: 6px 4px;">${user.phone}</td>
        </tr>
        <tr>
          <td style="text-align: left; font-weight: 600; padding: 6px 4px;">EarthID</td>
          <td style="text-align: right; padding: 6px 4px;">${user.earthId}</td>
        </tr>
      </table>
    </div>
  `,
  width: 500,
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  showCloseButton: true,
  confirmButtonColor: '#3085d6',
  confirmButtonText: 'Okay',
  customClass: {
    popup: 'swal-custom'
  }
  
 
});

  } else {
    //Swal.fire('Error', 'Failed to fetch user info', 'error');
     Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Failed to fetch user info.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
  }
};

const handleDeleteUser = async (earthId) => {
  const userData = await getUserDetailsByEarthId(earthId);
  console.log('This is the userData:', userData);


  if (!userData?.publicKey) {
    // Swal.fire({
    //   title: 'Error',
    //   text: 'Public key not found. Cannot delete user.',
    //   icon: 'error',
    //   background: darkMode ? '#1e1e2f' : '#ffffff',
    //   color: darkMode ? '#f1f1f1' : '#000000',
    //   confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
    //   iconColor: darkMode ? '#ff6b6b' : undefined,
    // });

     Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Public key not found. Cannot delete user.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
});
    return;
  }

  const confirm = await Swal.fire({
    title: 'Confirm Delete',
    text: `Delete user ${userData.username}?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
    background: darkMode ? '#1e1e2f' : '#ffffff',
    color: darkMode ? '#f1f1f1' : '#000000',
    confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
    cancelButtonColor: darkMode ? '#555' : '#aaa',
    iconColor: darkMode ? '#ffd369' : undefined,
  });

  if (confirm.isConfirmed) {
    const res = await deleteUserByEarthId(earthId, userData.publicKey);
    console.log('Delete API response:', res);

    if (res?.earthId === earthId || res?.username === userData.username) {
      const mappingDeleteRes = await deleteWalletMappingByEarthId(earthId);
      console.log("✅ Mapping delete response:", mappingDeleteRes);

      if (!mappingDeleteRes) {
        Swal.fire({
          title: 'Error',
          text: 'Failed to delete user.',
          icon: 'error',
          background: darkMode ? '#1e1e2f' : '#ffffff',
          color: darkMode ? '#f1f1f1' : '#000000',
          confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
          iconColor: darkMode ? '#ff6b6b' : undefined,
        });
        return;
      }

      if (user.Id) {
        const updatedList = await getWalletMappingsByIssuer(user.Id);
        setCertificates(updatedList);
        setCurrentPage(1);
      }

      Swal.fire({
        title: 'Deleted!',
        text: 'User has been deleted.',
        icon: 'success',
        background: darkMode ? '#1e1e2f' : '#ffffff',
        color: darkMode ? '#f1f1f1' : '#000000',
        confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
        iconColor: darkMode ? '#00ffae' : undefined,
      });

    } else {
      Swal.fire({
        title: 'Error',
        text: 'Failed to delete user.',
        icon: 'error',
        background: darkMode ? '#1e1e2f' : '#ffffff',
        color: darkMode ? '#f1f1f1' : '#000000',
        confirmButtonColor: darkMode ? '#9a0cec' : '#3085d6',
        iconColor: darkMode ? '#ff6b6b' : undefined,
      });
    }
  }
};





  const paginatedCertificates = certificates.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(certificates.length / itemsPerPage);

  return (
    <div className="page issue-layout">
      <h2 className="issue-title">Issue wallet</h2>

      <div className="card-container">
        <div
          className="issue-card"
          onClick={() => { setFormMode('manual'); setShowForm(true); }}
        >
          <FaPenFancy className="card-icon" />
          <h3>Manual Issuance</h3>
          <p>Fill out wallet info one by one manually.</p>
        </div>
        <div
          className="issue-card"
          onClick={() => { setFormMode('bulk'); setShowForm(true); }}
        >
          <FaFileUpload className="card-icon" />
          <h3>Bulk Issuance</h3>
          <p>Upload an Excel file to issue multiple wallets.</p>
        </div>
      </div>

      {showForm && (
        <div className="popup-form-overlay">
          <div className="popup-form">
            <span className="close-popup" onClick={() => setShowForm(false)}>&times;</span>
            {formMode === 'manual' ? (
              <>
                <h3>Manual Wallet Issuance</h3>
                <form onSubmit={handleSubmit}>
                  <label>First Name:
                    <input type="text" name="name" value={formData.name} onChange={handleChange} />
                  </label>
                  <label>Last Name:
                    <input type="text" name="lname" value={formData.lname} onChange={handleChange} />
                  </label>
                  <label>Email:
                    <input type="email" name="email" value={formData.email} onChange={handleChange} />
                  </label>
                  <label>Phone Number:</label>
                  <div className="phone-input-group">
                    <PhoneInput
  country={'gb'}
  value={`${formData.countryCode.replace('+', '')}${formData.phone}`}
  onChange={(value, data) => {
    const dialCode = data.dialCode;
    const cleaned = value.replace(/[^0-9]/g, '');

    // remove country code if present
    const actualPhone = cleaned.startsWith(dialCode)
      ? cleaned.slice(dialCode.length)
      : cleaned;

    setFormData({
      ...formData,
      phone: actualPhone,
      countryCode: `+${dialCode}`
    });
  }}
  inputProps={{
    name: 'phone',
    required: true,
    autoFocus: false
  }}
  containerStyle={{ width: '100%' }}
/>

</div>
                  <div className="popup-buttons center-submit">
                    <button type="submit" className="submit-btn">Issue Wallet</button>
                  </div>
                </form>
              </>
            ) : (
              <>
                <h3>Bulk Wallet Issuance</h3>
                <p className="instruction-text">
        Please upload an Excel file with the required fields. You can download a sample format below:
      </p>

      <button
        className="download-sample-btn"
        onClick={() => {
          const link = document.createElement('a');
          link.href = '/template/Wallet-Issuance.xlsx'; // Place this file in your `public/` folder
          link.download = 'sample-wallet-template.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      >
        📥 Download Sample Excel
      </button>
      <hr className='popup-hr'/>
                <form>
                  <label>Select Excel File:
                    <input
  type="file"
  name="file"
  accept=".xlsx,.xls"
  onChange={(e) => {
    const file = e.target.files?.[0];
    if (file) {
      console.log('✅ File selected:', file.name);
      setBulkFile(file);
    } else {
      console.log('⚠️ No file selected');
    }
  }}
/>
                  </label>
                  <div className="popup-buttons center-submit">
                   <button
  type="button"
  className="submit-btn"
  onClick={() => handleBulkUpload()}
>
  Upload
</button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {!showForm && (
        <div className="table-section">
  <h3>Recently Issued Wallets</h3>

  {paginatedCertificates.length === 0 ? (
    <div className="no-data-message">
      <p>No wallets found. Please issue a wallet to see entries here.</p>
    </div>
  ) : (
    <>
      <table>
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Name</th>
            <th>EarthID ID</th>
            <th>Issuer ID</th>
            <th>Created At</th>
            {/* <th className="icon-col">QR</th> */}
             <th className="icon-col">View</th>
            <th className="icon-col">Delete</th>
          </tr>
        </thead>
        <tbody>
          {paginatedCertificates.map((mapping, index) => (
            <tr key={mapping.id || mapping.wallet_id}>
              <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td>{mapping.name}</td>
              <td>{mapping.wallet_id}</td>
              <td>{mapping.issuer_id}</td>
              <td>{mapping.created_at}</td>
              {/* <td className="icon-col">
  <FaQrcode
    className="table-icon icon-qr"
    style={{ cursor: 'pointer' }}
    onClick={() => {
      const qrData = {
        earthId: mapping.walletId,
        bucketName: `idv-sessions-${mapping.issuerId?.toLowerCase()}`
      };
      const encrypted = btoa(JSON.stringify(qrData));
      Swal.fire({
        title: 'QR Code',
        html: `<img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(encrypted)}" />`,
         background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  customClass: {
    popup: 'swal-custom'
  }
      });
    }}
  />
</td> */}

              <td className="icon-col">
  <FaEye
    className="table-icon icon-view"
    style={{ cursor: 'pointer' }}
    onClick={() => handleViewUser(mapping.wallet_id)}
  />
</td>
<td className="icon-col">
  <FaTrash
    className="table-icon icon-delete"
    style={{ cursor: 'pointer' }}
    onClick={() => handleDeleteUser(mapping.wallet_id)}
  />
</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination-controls">
        <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
          <FaArrowLeft />
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
          <FaArrowRight />
        </button>
      </div>
    </>
  )}
</div>


      )}
    </div>
  );
}

export default IssueWallet;